module.exports = __webpack_public_path__ + "static/desktop-wallpaper-ed7713789a9afcbcb60b1116b16a8bb2.png";